import { gql, useQuery } from '@apollo/client';
import { useCurrentMemberContext } from 'src/contexts';

export const GET_GANTT_BY_ID = gql`
  query getGanttById($ganttId: String!) {
    getGanttById(ganttId: $ganttId) {
      _id
      name
      holidayLocationId
      holidayLocation {
        _id
        name
      }
      colorSchema {
        holidayColor
        todayColor
        weekendColor
      }
      weekends
    }
  }
`;

export const useGetCurrentGantt = () => {
  const { ganttId } = useCurrentMemberContext();
  const { data, loading } = useQuery(GET_GANTT_BY_ID, { variables: { ganttId } });
  const gantt = data?.getGanttById || {};

  return { loading, gantt };
};
